<script setup lang="ts">
import type { AlertSummarySection } from '../composables/useAlertSummary'
import type { AlertStepId } from '../service/alertValidator'

import AlertSummaryPanel from './AlertSummaryPanel.vue'

import { useI18n } from '@/shared/i18n'
import { Icon } from '@/shared/ui'

defineProps<{
  sections: AlertSummarySection[]
  editableSteps: readonly AlertStepId[]
}>()
const emit = defineEmits<{ edit: [step: AlertStepId] }>()
const { t } = useI18n()
</script>

<template>
  <div class="review-step grid gap-lg">
    <AlertSummaryPanel
      :sections="sections"
      active-step="review"
      editable
      :editable-steps="editableSteps"
      @edit="emit('edit', $event)"
    />
    <div
      class="review-step__ready flex gap-sm py-md px-lg border border-success-soft rounded-lg bg-success-soft"
    >
      <span
        class="review-step__ready-icon grid shrink-0 place-items-center w-8 h-8 mt-0.5 rounded-full bg-success text-surface"
        aria-hidden="true"
      >
        <Icon name="check" :size="14" />
      </span>
      <div>
        <p
          class="review-step__ready-title mt-0 mx-0 mb-[0.15rem] text-success text-[0.875rem] font-semibold"
        >
          {{ t('alerts.review.readyTitle') }}
        </p>
        <p class="review-step__ready-body m-0 text-success text-[0.875rem] opacity-80">
          {{ t('alerts.review.readyBody') }}
        </p>
      </div>
    </div>
  </div>
</template>
